import { EstablishmentCategory } from '@/modules/accredited-establishments/api/types'
import { MarkerWithIconProps } from '../../Marker'

const getMarkerProperties = (
  category: EstablishmentCategory
): MarkerWithIconProps => {
  const markerPropertiesMap: {
    [key in EstablishmentCategory]: MarkerWithIconProps
  } = {
    HOSPITAL: {
      icon: 'icHospital',
      iconColor: 'text-sys-color-content-on-brand',
      backgroundColor: 'bg-gl-color-shades-magenta-60'
    },
    EMERGENCY_UNITY: {
      icon: 'icAlertRotatinLight',
      iconColor: 'text-sys-color-content-on-brand',
      backgroundColor: 'bg-gl-color-shades-magenta-90'
    },
    /*
     * O fundo claro da maternidade nao contrasta com icone branco, entao o
     * handoff usa icone escuro nessa categoria.
     */
    MATERNITY: {
      icon: 'icBaby',
      iconColor: 'text-gl-color-shades-magenta-100',
      backgroundColor: 'bg-gl-color-shades-magenta-10'
    },
    LABORATORY: {
      icon: 'icLab',
      iconColor: 'text-sys-color-content-on-brand',
      backgroundColor: 'bg-gl-color-shades-magenta-30'
    },
    SPECIALIST: {
      icon: 'icStethoscope',
      iconColor: 'text-sys-color-content-on-brand',
      backgroundColor: 'bg-gl-color-shades-magenta-70'
    }
  }

  const defaultMarkerProperties: MarkerWithIconProps = {
    icon: 'icHospital',
    iconColor: 'text-sys-color-content-on-brand',
    backgroundColor: 'bg-gl-color-shades-magenta-60'
  }

  return markerPropertiesMap[category] || defaultMarkerProperties
}

export { getMarkerProperties }
